"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindowToWorkerHandler = void 0;
const WorkerToWindowHandler_1 = require("./WorkerToWindowHandler");
class WindowToWorkerHandler {
    constructor(windowSelf, worker, session) {
        this.windowSelf = windowSelf;
        this.worker = worker;
        this.session = session;
    }
    onmessage(messageEvent) {
        if (typeof messageEvent.data === "object" &&
            WorkerToWindowHandler_1.WorkerToWindowHandler.MESSAGE_KEY_POST in messageEvent.data) {
            const message = messageEvent.data[WorkerToWindowHandler_1.WorkerToWindowHandler.MESSAGE_KEY_POST];
            this.session
                .authenticateHeaders(message.resource, message.method, new Headers(message.headersUnauthenticatedRaw))
                .then((headersAuthenticated) => {
                const messageResponse = {
                    messageId: message.messageId,
                    headersAuthenticatedRaw: [...headersAuthenticated.entries()],
                };
                this.worker.postMessage({
                    [WorkerToWindowHandler_1.WorkerToWindowHandler.MESSAGE_KEY_RESPONSE]: messageResponse,
                });
            })
                .catch((error) => {
                const messageResponse = {
                    messageId: message.messageId,
                    errorMessage: error.message,
                };
                this.worker.postMessage({
                    [WorkerToWindowHandler_1.WorkerToWindowHandler.MESSAGE_KEY_RESPONSE]: messageResponse,
                });
            });
            return true;
        }
        return false;
    }
}
exports.WindowToWorkerHandler = WindowToWorkerHandler;
//# sourceMappingURL=WindowToWorkerHandler.js.map